var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import ScreenMessage from '../../../modal/content/utils/ErrorMessage';
import { ConfigContext } from '../../../context';
import { translate } from '../../../strings/i18n';
import getImages from '../../../modal/content/helpers/get-images';
var ConfirmedUserAdded = function () {
    var config = useContext(ConfigContext).config;
    var ladySuccess = getImages({ config: config }).ladySuccess;
    return (_jsx(ScreenMessage, { image: ladySuccess, id: "mch-first-name-business-error", title: translate('successfulMessageBox.title'), subTitle: _jsxs(_Fragment, { children: [translate('successfulMessageBox.subtitle'), _jsx(Body, __assign({ isInline: true, weight: "bold" }, { children: translate('successfulMessageBox.bold') })), _jsx(Body, { children: translate('successfulMessageBox.waitTimeToBeReflected') })] }) }));
};
export default ConfirmedUserAdded;
